/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result of any check in general. For example, DNS text records check or file upload
 * @export
 * @interface GeneralCheckResult
 */
export interface GeneralCheckResult {
    /**
     * If check passed successfully
     * @type {boolean}
     * @memberof GeneralCheckResult
     */
    valid?: boolean;
    /**
     * Short description if result is negative
     * @type {string}
     * @memberof GeneralCheckResult
     */
    description?: string;
}

/**
 * Check if a given object implements the GeneralCheckResult interface.
 */
export function instanceOfGeneralCheckResult(value: object): boolean {
    return true;
}

export function GeneralCheckResultFromJSON(json: any): GeneralCheckResult {
    return GeneralCheckResultFromJSONTyped(json, false);
}

export function GeneralCheckResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): GeneralCheckResult {
    if (json == null) {
        return json;
    }
    return {
        
        'valid': json['valid'] == null ? undefined : json['valid'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function GeneralCheckResultToJSON(value?: GeneralCheckResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'valid': value['valid'],
        'description': value['description'],
    };
}

